import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import VideoCard from "@/components/VideoCard";
import NativeBannerAd from "@/components/ads/NativeBannerAd";

export const CategoryView = () => {
  const { slug } = useParams();
  const [items, setItems] = useState(null);
  const [name, setName] = useState("");

  useEffect(() => {
    api.get("/categories").then((r) => {
      const cat = r.data.find((c) => c.slug === slug);
      setName(cat ? cat.name : slug);
    });
    api
      .get("/videos", { params: { category: slug, sort: "latest", limit: 200 } })
      .then((r) => setItems(r.data.items));
  }, [slug]);

  return (
    <div className="mx-auto max-w-7xl px-4 pt-6 md:px-12 md:pt-16">
      <div className="mb-8 animate-fade-up md:mb-10">
        <div className="text-[10px] uppercase tracking-[0.32em] text-[#e60039] md:text-xs">
          Category
        </div>
        <h1
          data-testid="category-title"
          className="mt-2 font-display text-3xl tracking-tight text-[#f2f2f2] sm:text-4xl md:mt-3 md:text-5xl lg:text-6xl"
        >
          {name}
        </h1>
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 sm:gap-8 lg:grid-cols-3 xl:grid-cols-4">
        {!items &&
          Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="aspect-video w-full skeleton rounded-sm" />
          ))}
        {items && items.map((v) => <VideoCard key={v.id} video={v} />)}
      </div>
      <NativeBannerAd />
      {items && items.length === 0 && (
        <div className="rounded-sm border border-dashed border-[#1a1a1a] p-12 text-center text-[#666]">
          Nothing in this category yet.
        </div>
      )}
    </div>
  );
};

export default CategoryView;
